/**
 * Normalise API / mutation errors for user-facing toasts.
 *
 * Renamed from ``extractApiError`` to ``extractMutationError`` to avoid the
 * collision with the data-layer ``extractApiError`` (src/data/api.js), which
 * returns the raw error payload. This one returns a user-facing string.
 *
 * @param {unknown} err
 * @param {string} [fallback]
 * @returns {string}
 */
export function extractMutationError(err, fallback = 'Ocorreu um erro.') {
  if (typeof err === 'string') return err;
  if (err instanceof Error && err.message) return err.message;
  if (err?.detail) {
    return typeof err.detail === 'string' ? err.detail : JSON.stringify(err.detail);
  }
  if (Array.isArray(err?.non_field_errors) && err.non_field_errors[0]) {
    return String(err.non_field_errors[0]);
  }
  if (err && typeof err === 'object') {
    const key = Object.keys(err).find(
      (field) => Array.isArray(err[field]) && err[field][0],
    );
    if (key) {
      const message = String(err[key][0]);
      const plainMessageFields = new Set([
        'amount',
        'default_monthly_budget',
        'non_field_errors',
      ]);
      if (plainMessageFields.has(key)) {
        return message;
      }
      const labels = {
        debt_amount: 'Valor em dívida',
        current_balance: 'Valor em dívida',
        investment_return_type: 'Tipo de retorno',
        expected_annual_return: 'Retorno anual estimado',
        interest_rate: 'TAEG',
      };
      const label = labels[key] || key;
      return `${label}: ${message}`;
    }
  }
  return fallback;
}
